<template>
  <div class="sureorder">
    <div class="address_title">
      <div class="address_title_left">
        <img @click="_return()" src="../../images/lujing.png" />
      </div>待接单详情
    </div>
    <div class="center_title">
      <div class="center_title_img">
        <img src="../../images/address_label.png" />
      </div>

      <div class="center_title_text">
        <div>
          收货人:{{content.name}}
          <span>{{content.phone}}</span>
        </div>
        <div>{{content.addr}}&nbsp;&nbsp;&nbsp; {{content.address}}</div>
      </div>
    </div>

    <div class="message">
      <h4>买家留言</h4>
      {{content.msg}}
    </div>

    <div class="list">
      <div>
        <span>商品列表</span>
      </div>
      <div class="content_list" v-for="item in content.list" :key="item.id">
        <div class="divleft">{{item.name}}</div>
        <div class="divright">
          <div>
            <span>￥{{item.money}}</span>
          </div>
          ×{{item.count}}
        </div>
      </div>
    </div>

    <div class="pay">
      <div>
        <span>支付方式：货到付款</span>
      </div>
      <div>
        <span>商品应付金额：</span>
        <div>
          <span>￥</span>
          {{content.money}}
        </div>
      </div>
    </div>
    <p class="bottom_dd">订单编号：{{content.number}}</p>
  </div>
</template>
<script>
//待接单详情页面

import API from "../../lmj_Api/api";
export default {
  data() {
    return {
      name: "DetailsWaiting",
      content: "",
      money: ""
    };
  },
  mounted() {
    this.get_content();
  },
  methods: {
    _return() {
      this.$router.go(-1);
    },
    get_content() {
      let url = API.OrdersDetails;
      let parent_id = this.$route.params.id; // 获取不到跳转 传来的参数
      let data = {
        order_id: parent_id
      };
      var that = this;
      this.axios
        .post(url, data)
        .then(function(response) {
          let _data = response.data;
          if (_data.code == 200) {
            that.content = _data.data;
            console.log(that.content);
          }
        })
        .catch(function(response) {
          //出错处理
        });
    }
  }
};
</script>
<style lang="less" scoped>
.sureorder{
  height: calc(~"(100% - 0.88rem)");
}
// 表头
.address_title {
  width: 7.5rem;
  height: 0.88rem;
  background: linear-gradient(
    90deg,
    rgba(123, 212, 255, 1) 0%,
    rgba(92, 186, 255, 1) 100%
  );
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 0.88rem;
  position: fixed;
  top: 0;
  left: 0;
}
.address_title > div {
  position: absolute;
  top: 0rem;
  text-align: center;
}

.address_title > div > img {
  width: 0.18rem;
  height: 0.34rem;
  display: inline-block;
  vertical-align: middle;
}

.address_title > .address_title_left {
  left: 0rem;
  width: 1.06rem;
  height: 100%;
  line-height: 0.88rem;
}
// 表头end




.center_title {
  margin-top: 0.88rem;
  width: 100%;
  min-height: 1.52rem;
  border-bottom: 0.1rem solid rgba(237, 237, 237, 1);
}

.center_title_img {
  width: auto;
  height: 100%;
  line-height: 1.52rem;
  display: inline-block;
  vertical-align: middle;
  margin-left: 0.3rem;
  margin-right: 0.38rem;
}

.center_title_img > img {
  height: 0.3rem;
  display: inline-block;
  vertical-align: middle;
}

.center_title_text {
  width: auto;
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}

.center_title_text > div {
  width: 6rem;
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(109, 109, 109, 1);
  line-height: 0.42rem;
  margin-top: 0.08rem;
}

.message {
  width: 6.88rem;
  min-height: 1.44rem;
  border-bottom: 0.1rem solid rgba(237, 237, 237, 1);
  padding: 0.3rem;
  font-size: 0.24rem;
  h4 {
    margin: 0.02rem;
    padding: 0 0 0.1rem 0rem;
  }
}

.message > div {
  margin-left: 0.3rem;
  margin-top: 0.22rem;
  font-size: 0.3rem;
  color: rgba(109, 109, 109, 1);
  font-family: PingFangSC-Medium, PingFang SC;
}

input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(153, 153, 153, 1);
}

input::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(153, 153, 153, 1);
}

input:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(153, 153, 153, 1);
}

input:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(153, 153, 153, 1);
}

.message > input {
  font-size: 0.26rem;
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 0.36rem;
  border: 0rem;
  margin-left: 0.3rem;
  margin-top: 0.22rem;
  width: 90%;
}

.list {
  width: 6.9rem;
  margin: auto;
}

.list > div {
  border-bottom: 0.02rem solid rgba(237, 237, 237, 1);
}

.list > div > span {
  display: block;
  height: 0.86rem;
  line-height: 0.86rem;
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(109, 109, 109, 1);
}

.list .content_list {
  padding: 0.22rem 0;
  height: 1rem;
  width: 100%;
}

.list > div > .divleft {
  float: left;
  width: 2.7rem;
  height: 1rem;
  font-size: 0.28rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(74, 74, 74, 1);
}

.list > div > .divright {
  float: right;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(153, 153, 153, 1);
  text-align: right;
}
.list > div > .divright > div {
  font-size: 0.22rem;
  height: 0.53rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(74, 74, 74, 1);
}

.list > div > .divright > div > span {
  font-size: 0.32rem;
}
.pay {
  padding: 0.2rem;
  font-size: 0.23rem;
}
.pay > div {
  text-align: right;
  margin-right: 0.3rem;
}

.pay > div > span {
  font-size: 0.26rem;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(74, 74, 74, 1);
  line-height: 0.36rem;
}

.pay > div > div {
  font-size: 0.24rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #ff5d33;
  display: inline-block;
  vertical-align: middle;
}

.pay > div > div > span {
  font-size: 0.24rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(255, 93, 51, 1);
}

.pay > div {
  margin-top: 0.2rem;
}

.new {
  width: 7.5rem;
  height: 1.08rem;
  background: linear-gradient(
    90deg,
    rgba(123, 212, 255, 1) 0%,
    rgba(92, 186, 255, 1) 100%
  );
  font-size: 0.32rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(255, 255, 255, 1);
  line-height: 1.08rem;
  position: fixed;
  bottom: 0rem;
  left: 0rem;
  border: 0rem;
  border-radius: 0rem;
  outline: 0rem;
}

//尾巴
.bottom_dd {
  padding: 0.26rem;
  width: 6.88rem;
  height: 1.3rem;
  font-size: 0.24rem;
  margin: 0;
  border-top: 0.1rem solid rgba(237, 237, 237, 1);
  color: #000;
}
// 尾巴end
</style>


// WEBPACK FOOTER //
// src/components/sym/DetailsWaiting.vue